// Platform Costs dashboard + trace list — `/traces`. Aggregate charts (cost,
// calls, latency, per-model / per-source rollups) over /v1/trace-timeseries
// plus the recent-traces table over /v1/traces. Rows deep-link into the
// flame-graph view at `/traces/:traceId`. `?scope=all-orgs` switches Formant
// staff to the cross-org view (/v1/admin/platform-costs); ignored for others.
import { createFileRoute } from '@tanstack/react-router';

import { TracesPage } from '../../components/traces/TracesPage';

export interface IPlatformCostsSearch {
  scope?: 'all-orgs';
}

export const Route = createFileRoute('/traces/')({
  validateSearch: (raw: Record<string, unknown>): IPlatformCostsSearch => ({
    scope: raw.scope === 'all-orgs' ? 'all-orgs' : undefined,
  }),
  component: TracesPage,
});
